var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",attrs:{"id":'cs-'+_vm.identify}},_vm._l((_vm.number),function(n,i){return _c('span',{key:_vm.identify+'-'+n+'-'+i,staticClass:"counter-style",class:{'resolution':_vm.is_res}},[_vm._v(_vm._s(n))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }